import { render, staticRenderFns } from "./delivery-summary.vue?vue&type=template&id=01e756d0&"
import script from "./delivery-summary.vue?vue&type=script&lang=js&"
export * from "./delivery-summary.vue?vue&type=script&lang=js&"
import style0 from "./delivery-summary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports